import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { AD_DEFAULT, CLI_CINEMA_CLIENT_ID, FEATURES, PROGRAM_CINEMAS, PROGRAM_CLI_MOVIES_ITEMS } from '../../../constants/state'
import EditAd from '../../PageEditItem/present/EditAd'
import getMovieSortedByTitle from '../../../functions/getMoviesSortedByTitle'
import { adsAddItem } from '../../../actions'
import { getTranslationString } from '../../Translation/cont/Translation'

const mapStateToProps = state => ({
    itemData: AD_DEFAULT,
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    cliCinemas: getData(state, PROGRAM_CINEMAS),
    features: getData(state, FEATURES),
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    transNoMovieSelected: state.getIn(['translation', 'strings', 'content_no_movie_selected']),
    currentLang: state.getIn(['translation', 'currentLang']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(adsAddItem(itemData, ownProps.closePagePath))
    }
})

const AddAdContainer = ({itemData, onUpdateItem, movieData, cliCinemas, closePagePath, features, suffixEdit, clientCinemaId, transNoMovieSelected, currentLang}) => <EditAd 
    itemData={itemData}
    cliCinemas={cliCinemas}
    sortedMovieDataKeys={getMovieSortedByTitle(movieData)}
    movieData={movieData}
    suffixEdit={suffixEdit}
    closePagePath={closePagePath}
    onUpdateItem={onUpdateItem}
    features={features}
    clientCinemaId={clientCinemaId}
    transNoMovieSelected={getTranslationString(transNoMovieSelected, currentLang)}
/>

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(AddAdContainer)
